import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export class Win32_ComputerSystemInfoJson {
//    caption: string;
//    description: string;
//    host_name: string;
//    netbios_domain: string;
//    manufacturer_name: string;
//    model: string;
//    name: string;
//    num_of_processors: string;
//    total_physical_memory: string;
//    user_name: string;
//    workgroup: string;
//    laptop: string;
//}

export class Win32_ComputerSystemInfo extends InfoSet {
	//public static FromJson(json: Win32_ComputerSystemInfoJson, device:Device): Win32_ComputerSystemInfo {
 //       var result = new Win32_ComputerSystemInfo(device);

 //       if (json.caption !== undefined)
 //           result.Caption = json.name;
 //       if (json.description !== undefined)
 //           result.Description = json.description;
 //       if (json.host_name !== undefined)
 //           result.DNSHostname = json.host_name;
 //       if (json.netbios_domain !== undefined)
 //           result.Domain = json.netbios_domain;
 //       if (json.manufacturer_name !== undefined)
 //           result.Manufacturer = json.manufacturer_name;
 //       if (json.model !== undefined)
 //           result.Model = json.model;
 //       if (json.name !== undefined)
 //           result.Name = json.name;

 //       if (json.num_of_processors !== undefined) {
 //           result.NumberOfProcessors = parseInt(json.num_of_processors);
 //       }
 //       if (json.total_physical_memory !== undefined) {
 //           result.TotalPhysicalMemory = parseInt(json.total_physical_memory);
 //       }

 //       if (json.user_name !== undefined)
 //           result.Username = json.user_name;
 //       if (json.workgroup !== undefined)
 //           result.Workgroup = json.workgroup;
 //       if (json.laptop !== undefined) {
 //           result.IsLaptop = false;
 //           if (json.laptop == 'True')
 //               result.IsLaptop = true;
 //       }

	//	return result;
	//}

	public Caption: string;
	public get HasCaption():boolean{
        return !!this.Caption;
	}

	public Description: string;
	public get HasDescription(): boolean {
		return !!this.Description;
	}

	public DNSHostname:string;
	public get HasDNSHostname(): boolean {
        return !!this.DNSHostname;
	}

	public Domain: string;
	public get HasDomain(): boolean {
		return !!this.Domain;
	}

	public Manufacturer: string;
    public get HasManufacturer(): boolean {
        return !!this.Manufacturer;
	}

	public Model: string;
	public get HasModel(): boolean {
        return !!this.Model;
	}

    public Name: string;
    public get HasName(): boolean {
        return !!this.Name;
    }

	public NumberOfProcessors: number;
    public get HasNumberOfProcessors(): boolean {
        return this.NumberOfProcessors > 0;
    }

    public TotalPhysicalMemory: number;
    public get HasTotalPhysicalMemory(): boolean {
        return this.TotalPhysicalMemory > 0;
    }
		
	public Username:string
	public get HasUsername(): boolean {
		return !!this.Username;
	}

	public Workgroup: string;
	public get HasWorkgroup(): boolean {
		return !!this.Workgroup;
	}

    public IsLaptop: boolean;

	constructor(device: Device) {
		super(device);
		this.Init();
	}

    private Init() {
        this.Caption = "";
        this.Description = "";
        this.DNSHostname = "";
        this.Domain = "";
        this.Manufacturer = "";
        this.Model = "";
        this.Name = "";
        this.NumberOfProcessors = 0;
        this.TotalPhysicalMemory = 0;
        this.Username = "";
        this.Workgroup = "";
        this.IsLaptop = false;
	}

	public Write(obj: any, context: any): void {
		obj.w32_comp_sys_info = {};
		obj = obj.w32_comp_sys_info;

		if (this.HasCaption)
			obj.caption = this.Caption;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasDNSHostname)
			obj.host_name = this.DNSHostname;

		if (this.HasDomain)
			obj.netbios_domain = this.Domain;

		if (this.HasManufacturer)
			obj.manufacturer_name = this.Manufacturer;

		if (this.HasModel)
			obj.model = this.Model;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasNumberOfProcessors)
			obj.num_of_processors = ValueEncoder.EncodeInteger(this.NumberOfProcessors);

		if (this.HasTotalPhysicalMemory)
			obj.total_physical_memory = ValueEncoder.EncodeInteger(this.TotalPhysicalMemory);

		if (this.HasUsername)
			obj.user_name = this.Username;

		if (this.HasWorkgroup)
			obj.workgroup = this.Workgroup;

		obj.laptop = ValueEncoder.EncodeBoolean(this.IsLaptop);
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_comp_sys_info)
			throw new Error();
		obj = obj.w32_comp_sys_info;

		if (obj.caption !== undefined)
			this.Caption = obj.caption;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.host_name !== undefined)
			this.DNSHostname = obj.host_name;

		if (obj.netbios_domain !== undefined)
			this.Domain = obj.netbios_domain;

		if (obj.manufacturer_name !== undefined)
			this.Manufacturer = obj.manufacturer_name;

		if (obj.model !== undefined)
			this.Model = obj.model;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.num_of_processors !== undefined)
			this.NumberOfProcessors = ValueEncoder.DecodeInteger(obj.num_of_processors);

		if (obj.total_physical_memory !== undefined)
			this.TotalPhysicalMemory = ValueEncoder.DecodeInteger(obj.total_physical_memory);

		if (obj.user_name !== undefined)
			this.Username = obj.user_name;

		if (obj.workgroup !== undefined)
			this.Workgroup = obj.workgroup;

		if (obj.laptop !== undefined)
			this.IsLaptop = ValueEncoder.DecodeBoolean(obj.laptop);
	}
}
